// extracted by mini-css-extract-plugin
export default {"wrapper":"AddressTo_wrapper__I753w","link":"AddressTo_link__ywz07"};